import { render, staticRenderFns } from "./RequestPOAPriceDlg.vue?vue&type=template&id=d9486fbc&scoped=true"
import script from "./RequestPOAPriceDlg.ts?vue&type=script&lang=ts&external"
export * from "./RequestPOAPriceDlg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9486fbc",
  null
  
)

export default component.exports